import React, { useContext, useState } from 'react'
import './ProductDisplay.css'
import { ShopContext } from '../../Context/ShopContext';

const ProductDisplay = (props) => {

    const { product } = props;

    const {
        addToCart,
        removeFromCart,
        cartItems
    } = useContext(ShopContext);

    const [showAddedPopup, setShowAddedPopup] = useState(false);

    const imageUrl = product.image;

    const quantity = cartItems[product.id] || 0;

    const handleAddToCart = () => {

        addToCart(product.id);

        setShowAddedPopup(true);

        setTimeout(() => {
            setShowAddedPopup(false);
        }, 2000);
    };

    const buyThroughWhatsApp = () => {

        const message = `Hey, I want to buy this particular product.

Product: ${product.name}
Price: ₹${product.new_price}
Link: ${window.location.href}`;

        const whatsappUrl =
            `https://wa.me/918017166452?text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className='productdisplay'>

            <div className="productdisplay-left">

                <div className="productdisplay-img-list">

                    <img src={imageUrl} alt='' />
                    <img src={imageUrl} alt='' />
                    <img src={imageUrl} alt='' />
                    <img src={imageUrl} alt='' />

                </div>

                <div className="productdisplay-img">

                    <img
    className={`productdisplay-main-img ${
        product.category !== "accounts" ? "vp-product-main-img" : ""
    }`}
    src={imageUrl}
    alt=''
/>

                </div>

            </div>

            <div className="productdisplay-right">

                <h1>{product.name}</h1>

                <div className="productdisplay-right-prices">

                    <div className="productdisplay-right-price-old">
                        ₹{product.old_price}
                    </div>

                    <div className="productdisplay-right-price-new">
                        ₹{product.new_price}
                    </div>

                </div>

                <div className='productdisplay-right-description'>
                    {product.description}
                </div>
                {product.category === "accounts" && (
    <div className="account-details">

        <div className="account-details-heading">
            <span>ACCOUNT DETAILS</span>
        </div>

        <div className="account-details-grid">

            <div className="account-detail">
                <span>REGION</span>
                <strong>
                    {product.region === "ind"
                        ? "India (IND)"
                        : product.region === "php"
                            ? "Philippines (PHP)"
                            : "Not Applicable"
                    }
                </strong>
            </div>

            <div className="account-detail">
                <span>CURRENT RANK</span>
                <strong>{product.current_rank}</strong>
            </div>

            <div className="account-detail">
                <span>PEAK RANK</span>
                <strong>{product.peak_rank}</strong>
            </div>

            <div className="account-detail">
                <span>PREMIUM SKINS</span>
                <strong>{product.premium_skins}</strong>
            </div>

            <div className="account-detail account-detail-full">
                <span>SELLER</span>
                <strong>{product.seller}</strong>
            </div>

        </div>

    </div>
)}


                {quantity === 0 ? (

                    <button
                        className="productdisplay-add-button"
                        onClick={handleAddToCart}
                    >
                        ADD TO CART
                    </button>

                ) : (

                    <div className="productdisplay-quantity-control">

                        <button
                            className="productdisplay-quantity-button"
                            onClick={() => removeFromCart(product.id)}
                        >
                            −
                        </button>

                        <span className="productdisplay-quantity">
                            {quantity}
                        </span>

                        <button
                            className="productdisplay-quantity-button"
                            onClick={() => addToCart(product.id)}
                        >
                            +
                        </button>

                    </div>

                )}


                <button
                    className="productdisplay-whatsapp-button"
                    onClick={buyThroughWhatsApp}
                >
                    BUY THROUGH WHATSAPP
                </button>
                

                
            </div>
                        {product.category === "accounts" && (
                <div className="account-security-section">

                    <div className="account-security-card">

                        <div className="account-security-icon">
                            <svg viewBox="0 0 64 64" fill="none">
                                <path
                                    d="M32 6L52 14V29C52 42 44 52 32 58C20 52 12 42 12 29V14L32 6Z"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M22 32L29 39L43 24"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>

                        <div>
                            <h3>100% Safe &amp; Secure</h3>
                            <p>All accounts are manually checked before delivery.</p>
                        </div>

                    </div>


                    <div className="account-security-card">

                        <div className="account-security-icon">
                            <svg viewBox="0 0 64 64" fill="none">
                                <circle
                                    cx="32"
                                    cy="32"
                                    r="21"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                />
                                <path
                                    d="M32 19V32L41 38"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M49 12L54 17"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M15 12L10 17"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>

                        <div>
                            <h3>Instant Delivery</h3>
                            <p>Receive your account instantly after purchase.</p>
                        </div>

                    </div>


                    <div className="account-security-card">

                        <div className="account-security-icon">
                            <svg viewBox="0 0 64 64" fill="none">
                                <path
                                    d="M32 7L38 11L45 10L49 17L56 21L54 29L57 36L51 41L49 49L41 50L35 56L28 52L20 54L16 47L9 43L11 35L7 28L13 22L14 14L22 13L28 8L32 7Z"
                                    stroke="currentColor"
                                    strokeWidth="3.5"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M22 32L29 39L43 24"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>

                        <div>
                            <h3>No Bans</h3>
                            <p>Our accounts are clean and ban-free.</p>
                        </div>

                    </div>


                    <div className="account-security-card">

                        <div className="account-security-icon">
                            <svg viewBox="0 0 64 64" fill="none">
                                <path
                                    d="M20 38V29C20 22 25 17 32 17C39 17 44 22 44 29V38"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                />
                                <rect
                                    x="12"
                                    y="34"
                                    width="10"
                                    height="18"
                                    rx="4"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                />
                                <rect
                                    x="42"
                                    y="34"
                                    width="10"
                                    height="18"
                                    rx="4"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                />
                                <path
                                    d="M52 46H56"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>

                        <div>
                            <h3>24/7 Support</h3>
                            <p>We are always here to help you.</p>
                        </div>

                    </div>

                </div>
            )}

            {showAddedPopup && (

                <div className="added-to-cart-popup">
                    Added to cart
                </div>

            )}

        </div>
    )
}

export default ProductDisplay